// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:30:45

export default {
  "id": "cyberpunk-corporation",
  "slug": "cyberpunk-corporation",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/60478b5f81a64e47a159fa44ed0e885c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/60478b5f81a64e47a159fa44ed0e885c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cyberpunk: Corporation",
      "description": "The corporation takes control of the city. You are the only one who can fight back and free the inhabitants.\nEnlist the support of local residents by completing their tasks. Activate the robot and break through the defense line.",
      "instructions": "WASD = move\nLeft-click = shoot\nRight-click = iron sight\nMouse wheel / 1-5 = change weapons\nLeft-shift = run\nC = crouch\nE = interact\nSpace = Jump",
      "genres": [
        "Adventure",
        "Shooter"
      ],
      "tags": [
        "3d",
        "cyberpunk",
        "guns",
        "police",
        "robot"
      ]
    },
    "zh-CN": {
      "title": "赛博朋克：公司",
      "description": "公司接管了城市。你是唯一能反击并解放居民的人。\n通过完成任务争取当地居民的支援。激活机器人，突破防御线。",
      "instructions": "WASD = 移动\n左键点击 = 射击\n右键点击 = 瞄准镜\n鼠标滚轮/1-5 = 切换武器\n左Shift = 跑步\nC = 蹲下\nE = 互动\n空格 = 跳跃",
      "genres": [
        "冒险",
        "射击"
      ],
      "tags": [
        "三维",
        "赛博朋克",
        "枪械",
        "警察",
        "机器人"
      ]
    },
    "zh-TW": {
      "title": "赛博朋克：公司",
      "description": "公司接管了城市。你是唯一能反擊並解放居民的人。透過完成當地居民的任務來争取他們的支持。啟動機器人並突破防禦線。",
      "instructions": "WASD = 移動\n左鍵點擊 = 射擊\n右鍵點擊 = 鐵鏡\n滑鼠滾輪 / 1-5 = 切換武器\n左Shift = 跑步\nC = 蹲下\nE = 互動\n空格鍵 = 跳躍",
      "genres": [
        "冒險",
        "射擊"
      ],
      "tags": [
        "3D",
        "赛博朋克",
        "槍械",
        "警察",
        "機器人"
      ]
    },
    "zh-HK": {
      "title": "赛伯朋克：集團",
      "description": "集團控制了城市。你是唯一能反擊並解放居民的人。\n透過完成當地居民的任務來獲取他們的支持。啟動機械人並突破防線。",
      "instructions": "WASD = 移動\n左鍵 = 射擊\n右鍵 = 瞄準鏡\n滑鼠輪 / 1-5 = 切換武器\n左Shift = 跑步\nC = 蹲下\nE = 互動\n空格 = 跳躍",
      "genres": [
        "冒險",
        "射擊"
      ],
      "tags": [
        "3D",
        "赛博朋克",
        "槍械",
        "警察",
        "機械人"
      ]
    },
    "ja": {
      "title": "サイバーパンク: コーポレーション",
      "description": "企業が都市を支配した。あなたは唯一反撃し、住民を解放できる存在だ。住民のサポートを獲得するために、彼らのタスクを完了し、ロボットを起動して防衛線を突破する。",
      "instructions": "WASD = 移動\n左クリック = シュート\n右クリック = 瞄準\nマウスホイール / 1-5 = 武器切り替え\n左Shift = 走行\nC = 伏せられる\nE = インタラクション\nスペース = ジャンプ",
      "genres": [
        "アドベンチャー",
        "シューティング"
      ],
      "tags": [
        "3D",
        "サイボーグ",
        "銃",
        "警察",
        "ロボット"
      ]
    },
    "ko": {
      "title": "시버팬크: 회사",
      "description": "기업이 도시를 통제합니다. 당신은 돌파구를 찾아 시민을 해방할 수 있는 유일한 사람입니다.\n지역 주민들의 지원을 받기 위해 그들의 임무를 완료하세요. 로봇을 활성화하고 방어선을突破하세요.",
      "instructions": "WASD = 이동\n좌 کلیック = 발사\n우 کلیック = Iron Sight\n마우스 휠 / 1-5 = 무기 전환\n좌 쉬프트 = 달리기\nC = 앉히기\nE = 상호작용\n스페이스 = 점프",
      "genres": [
        "모험",
        "총알게임"
      ],
      "tags": [
        "3D",
        "시빌팝",
        "소총",
        "경찰",
        "로봇"
      ]
    },
    "fr": {
      "title": "Cyberpunk: Corporation",
      "description": "La société prend le contrôle de la ville. Vous êtes le seul à pouvoir résister et libérer les habitants.\nRecrutez le soutien des résidents locaux en accomplissant leurs tâches. Activatez le robot et brisez la ligne de défense.",
      "instructions": "WASD = déplacement\nClic gauche = tirer\nClic droit = viseur\nRoue de la souris / 1-5 = changer d'armes\nAlt gauche = courir\nC = se prosterner\nE = interagir\nEspace = sauter",
      "genres": [
        "Aventure",
        "Tiroir"
      ],
      "tags": [
        "3D",
        "cyberpunk",
        "armes",
        "police",
        "robot"
      ]
    }
  }
};
